import { render, staticRenderFns } from "./ConfirmAccountStatusUpdate.vue?vue&type=template&id=6d8662d2&scoped=true"
import script from "./ConfirmAccountStatusUpdate.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountStatusUpdate.vue?vue&type=style&index=0&id=6d8662d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8662d2",
  null
  
)

export default component.exports